import * as React from 'react';
import { MenuItemLink, useGetIdentity } from 'react-admin';
import {
  GroupSharp,
  ListSharp,
  CreditCard,
  CallSplit,
  Map,
  More,
} from '@material-ui/icons';

import { getUserRoleAccess, getUserTypeAccess } from '../utils/getUserAccess';

export const Menu = () => {
  const { loading: identityLoading, identity } = useGetIdentity();
  const { roles, type } = identity || {};

  if (identityLoading) {
    return null;
  }

  const userRoleAccess = getUserRoleAccess(roles);
  const { developer: isDeveloper } = getUserTypeAccess(type);
  const { admin: isAdmin } = userRoleAccess;
  const isUserAccess = Object.values(userRoleAccess).includes(true);

  return (
    <div>
      {(isAdmin || isDeveloper) && isUserAccess ? (
        <MenuItemLink
          to="/users"
          primaryText="Users"
          leftIcon={<GroupSharp />}
        />
      ) : null}
      <MenuItemLink
        to="/transactions-v2"
        primaryText="Transactions"
        leftIcon={<CallSplit />}
      />
      <MenuItemLink
        to="/user-card"
        primaryText="Card users"
        leftIcon={<CreditCard />}
      />
      {isAdmin || isDeveloper ? (
        <MenuItemLink to="/geo-group" primaryText="Geo group" leftIcon={<More />} />
      ) : null}
      {isAdmin || isDeveloper ? (
        <MenuItemLink to="/geolocation" primaryText="Geolocation" leftIcon={<Map />} />
      ) : null}
      {isAdmin || isDeveloper ? (
        <MenuItemLink to="/logs" primaryText="Logs" leftIcon={<ListSharp />} />
      ) : null}
    </div>
  );
};
